require('./fin-accueil.scss');

import DemandeActions from '../../../../actions/demande.actions';
import { STEPS } from '../../../../utils/routes.util';

export default class FinAccueilComponent {
  constructor() {
    this.controller = FinAccueilController;
    this.template = require('./fin-accueil.html');
  }
}

// @ngInject
class FinAccueilController {

  constructor($scope, $ngRedux) {
    this.$ngRedux = $ngRedux;
    this.$scope = $scope;
    this.data = {};
  }

  $onInit() {
    // Demande de récupération de la demande avant connexion au state
    this.$ngRedux.dispatch(DemandeActions.loadDemande(STEPS.FIN_ACCUEIL));
    // Connexion au state récupérer les données modifiées
    const disconnect = this.$ngRedux.connect(
      state => {
        return {
          working: state.general.working,
          failure: state.demande.failure,
          fetching: state.demande.fetching,
          demande: state.demande.data,
          data: state.demande.data.finAccueil ? state.demande.data.finAccueil.asMutable({deep: true}) : this.data,
          typePersonne: state.demande.data.typePersonne,
          fin: state.demande.data.antenneAccessible ? !state.demande.data.antenneAccessible.source : null,
        };
      }
    )(this);

    // Déconnexion du state à la suppression du composant
    this.$scope.$on('$destroy', disconnect);
  }

  // Actions
  prevStep() {
    this.$ngRedux.dispatch(DemandeActions.updateFinAccueil(this.data, true));
  }

  nextStep() {
    this.$ngRedux.dispatch(DemandeActions.updateFinAccueil(this.data));
  }

}



// WEBPACK FOOTER //
// ./src/modules/accueil/components/fin-accueil/fin-accueil.component.js